import * as React from "react";

export const IconHomeFilled = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_38400_70864)">
      <path d="M12 3L4 9V21H9V14H15V21H20V9L12 3Z" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_38400_70864">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
